export { PrayerSpaceScreen as default } from '@/src/features/prayer-space/ui/screens/PrayerSpaceScreen/index'
